import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "../Css/Custom.css";
import Logo from "../Images/CK-Logo-removebg-preview-removebg-preview.png";

function Navbar() {

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userData, setUserData] = useState(null);

  const [services, setServices] = useState([]);
  const [serviceItems, setServiceItems] = useState({});
  const [activeDropdown, setActiveDropdown] = useState(null);

  // ======================
  // SLUG FUNCTION
  // ======================
  const slugify = (text) => {
    return text
      ?.toLowerCase()
      ?.trim()
      ?.replace(/&/g, "and")
      ?.replace(/[^\w\s-]/g, "")
      ?.replace(/\s+/g, "-");
  };

  // ======================
  // USER DATA
  // ======================
  const fetchUserData = async (userId) => {
    try {
      const res = await axios.get(
        `https://api.compliancekare.com/api/Compliance/GetUserDetail?UserId=${userId}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      setUserData(res.data);

    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const token = sessionStorage.getItem("token");

    if (token) {
      setIsLoggedIn(true);
      fetchUserData(29); // 👈 dynamic userId bhi kar sakte ho
    }
  }, []);

  const handleLogout = () => {
    sessionStorage.removeItem("token");
    setIsLoggedIn(false);
    setUserData(null);
  };

  // ======================
  // SERVICE TYPES
  // ======================
  const getServiceTypes = async () => {
    try {
      const { data } = await axios.get(
        "https://api.compliancekare.com/api/Compliance/GetServiceTypes"
      );

      setServices(data.data || []);

    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getServiceTypes();
  }, []);

  // ======================
  // SERVICES BY TYPE
  // ======================
  const getServicesByTypeId = async (id) => {
    if (serviceItems[id]) return;

    try {
      const { data } = await axios.get(
        `https://api.compliancekare.com/api/Compliance/ServicesByTypeId?ServiceTypeId=${id}`
      );

      setServiceItems((prev) => ({
        ...prev,
        [id]: data.data || [],
      }));

    } catch (error) {
      console.error(error);
    }
  };

  const handleDropdownClick = (id) => {
    setActiveDropdown(activeDropdown === id ? null : id);
    getServicesByTypeId(id);
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light sticky-top">
      <div className="container">

        {/* LOGO */}
        <Link to="/" className="navbar-brand">
          <img src={Logo} alt="logo" style={{ height: "50px" }} />
        </Link>

        {/* TOGGLE */}
        <button
          className="navbar-toggler"
          data-bs-toggle="collapse"
          data-bs-target="#nav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* MENU */}
        <div id="nav" className="collapse navbar-collapse">
          <ul className="navbar-nav ms-auto">

            {/* HOME */}
            <li className="nav-item">
              <Link to="/" className="nav-link">Home</Link>
            </li>

            {/* SERVICES DROPDOWN */}
            {services.map((service) => (
              <li key={service.id} className="nav-item dropdown">

                <span
                  className="nav-link dropdown-toggle"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleDropdownClick(service.id)}
                >
                  {service.serviceTypeName}
                </span>

                <ul className={`dropdown-menu ${activeDropdown === service.id ? "show" : ""}`}>
                  {serviceItems[service.id]?.length > 0 ? (
                    serviceItems[service.id].map((item) => (
                      <li key={item.id}>
                        <Link
                          className="dropdown-item"
                          to={`/service/${slugify(item.serviceName)}`}
                          state={{ id: item.id }}   // ✅ hidden ID pass
                        >
                          {item.serviceName}
                        </Link>
                      </li>
                    ))
                  ) : (
                    <li className="dropdown-item">Loading...</li>
                  )}

                </ul>
              </li>
            ))}

            {/* CONTACT */}
            <li className="nav-item">
              <Link to="/contact" className="nav-link">Contact</Link>
            </li>

            {/* LOGIN / USER */}
            {isLoggedIn && userData ? (
              <li className="nav-item dropdown">

                <a
                  className="nav-link dropdown-toggle"
                  role="button"
                  data-bs-toggle="dropdown"
                >
                  {userData?.data?.name}
                </a>

                <ul className="dropdown-menu">
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={handleLogout}
                    >
                      Logout
                    </button>
                  </li>
                </ul>

              </li>
            ) : (
              <li className="nav-item">
                <Link to="/login" className="nav-link">
                  <button
                    className="btn btn-outline-success"
                    style={{
                      border: "1px solid green",
                      color: "green",
                    }}
                  >
                    Login
                  </button>
                </Link>
              </li>
            )}

          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;